import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  withArrow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  withArrow = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0D0A07] disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-brand-amber text-brand-night hover:bg-brand-gold focus:ring-brand-amber shadow-amber cta-pulse border border-brand-ember/30',
    secondary: 'bg-brand-surface text-brand-cream hover:bg-brand-border focus:ring-brand-amber border border-brand-border',
    outline: 'bg-transparent text-brand-amber border-2 border-brand-amber hover:bg-brand-amber/10 focus:ring-brand-amber'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} onClick={e => {
    // Fire Meta Pixel AddToCart event before redirecting
    window.fbq?.('track', 'AddToCart', {
      content_name: 'Deep Sleep Cortisol Reset',
      content_ids: ['42098101125200'],
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
    window.location.href = 'https://www.versastorex.com/cart/42098101125200:1';
    props.onClick?.(e);
  }} {...props} data-id="element-155">
      {children}
      {withArrow && <ArrowRight className="ml-2 h-5 w-5" data-id="element-156" />}
    </button>;
}